import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchSofDocuments, deleteSofDocument , createSofDocument, extractSofData, formatOverride, fetchSingleCsof} from "../../apis/sofDocuments";

export const getSofDocument=createAsyncThunk("sofDocument/getsofDocument", async ({
    page = 0,
    pageSize = 25,
    jobId,
  }: {
    page?: number;
    pageSize?: number;
    jobId?: string;
  }, { rejectWithValue }) => {
    try {
        const response = await fetchSofDocuments(page, pageSize, jobId);
        return {
            data: response?.data,
            total: response?.meta?.total ?? response?.total,
          };
    } catch (error:any) {
        console.log("error->", error);
        return rejectWithValue(error.message);
    }
  });

export const createSofDocsThunk = createAsyncThunk(
  "createSof/post",
  async (
    params: { cargo_id: string; job_id: string; berth_id: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await createSofDocument(params);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to create CSOF document");
    }
  }
);

export const deleteSofDocumentThunk = createAsyncThunk(
  "sofDocument/delete",
  async (
    { csofId, }: { csofId: string},
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteSofDocument( csofId );
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to delete document");
    }
  }
);

export const updateCsofThunk = createAsyncThunk(
  "sofDocument/updateCsof",
  async (
    {
      csofId,
      jobId,
      berth_id,
      cargo_id,
      key
    }: { csofId: string; jobId: string; berth_id: string; cargo_id: string, key:any },
    { rejectWithValue }
  ) => {
    try {
      const response = await extractSofData(csofId, { jobId, berth_id, cargo_id, key });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to update document");
    }
  }
);

export const formatOverrideThunk = createAsyncThunk(
  "sofDocument/formatOverride",
  async (
    { csofId, companyFormat }: { csofId: string; companyFormat: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await formatOverride(csofId, companyFormat);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to override format");
    }
  }
);

export const fetchSingleCsofThunk = createAsyncThunk(
  "sofDocument/fetchSingle",
  async (csofId: string, { rejectWithValue }) => {
    try {
      const response = await fetchSingleCsof(csofId);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch CSOF record");
    }
  }
);

